import TimeSelect from './src/time-select.vue'

export default TimeSelect
